module.exports = __webpack_public_path__ + "img/66b22268bfff20c4d95ef0bb2f83ee13.d6461a6e.png";